import { jsx as n } from "react/jsx-runtime";
import { Suspense as p, lazy as t } from "react";
import '../assets/ODSIcon.css';/* empty css                 */
const a = t(() => import("./ODSAdd.DqUjkwFi.js")), S = t(() => import("./ODSAddCard.CaTS68Rh.js")), D = t(() => import("./ODSArrange.CLaPe219.js")), O = t(() => import("./ODSArrowDown.GAuZOo7w.js")), l = t(() => import("./ODSArrowLeft.DgYZavOh.js")), d = t(() => import("./ODSArrowRight.BbS48GEe.js")), u = t(
  () => import("./ODSArrowUTurnBackwards.BNUwn0iL.js")
), h = t(
  () => import("./ODSArrowUTurnForwards.Dk5ji6a-.js")
), g = t(() => import("./ODSArrowUp.BrO4j4Rt.js")), w = t(() => import("./ODSAutoLogin.0Psduw7p.js")), f = t(() => import("./ODSBackspace.C3nnpUbE.js")), b = t(() => import("./ODSBackward.DUQv4mZv.js")), v = t(() => import("./ODSCast.BtSfvu_8.js")), y = t(() => import("./ODSChangelog.C8h_TLEt.js")), k = t(() => import("./ODSCheckmark.BoBwhUnX.js")), C = t(() => import("./ODSCircleAdd.-v-gCjNN.js")), M = t(() => import("./ODSCircleClose.B-hkieH3.js")), W = t(
  () => import("./ODSCircleFastForward.BxmMJh7i.js")
), P = t(() => import("./ODSCircleMinus.Dc4lvJ7j.js")), A = t(() => import("./ODSCirclePause.CaN_JSkM.js")), F = t(() => import("./ODSCirclePlay.DKuPZuWY.js")), L = t(() => import("./ODSClose.B7LAeurK.js")), x = t(() => import("./ODSCompare.O3MybjG2.js")), T = t(() => import("./ODSCopyPaste.D92QoQG2.js")), I = t(() => import("./ODSCutPaste.BoS3PykX.js")), R = t(() => import("./ODSDelete.CaKWtvAD.js")), U = t(
  () => import("./ODSDisabledMicrophone.CwXpDrEq.js")
), B = t(() => import("./ODSDotGrid.Bqb2ZSr4.js")), E = t(() => import("./ODSDownload.CuaIcBu_.js")), z = t(
  () => import("./ODSDownloadFromCloud.CkGIqmtU.js")
), H = t(() => import("./ODSDragAndDrop.Dl19JXL4.js")), N = t(() => import("./ODSEdit.CH6f1CKv.js")), V = t(() => import("./ODSExport.DgrCm0ez.js")), G = t(() => import("./ODSFastForward.BkUNRzPt.js")), q = t(() => import("./ODSFilter.B_k2lX6L.js")), K = t(() => import("./ODSFilter2.DycQK86p.js")), Z = t(() => import("./ODSForward.wgysxu00.js")), j = t(() => import("./ODSGroup.Bvob93SX.js")), $ = t(() => import("./ODSImport.CKzM-iSa.js")), J = t(() => import("./ODSInstall.CZjM7drL.js")), Q = t(() => import("./ODSLaunch.DS59HysP.js")), X = t(
  () => import("./ODSLightDarkMode.WBcokREj.js")
), Y = t(() => import("./ODSLink.Dt5eXnhK.js")), _ = t(() => import("./ODSLogout.BwQNREz1.js")), tt = t(() => import("./ODSLoop.BvHddnBc.js")), ot = t(() => import("./ODSMagicWand.WbtqzSbr.js")), it = t(
  () => import("./ODSMaximizeScreen.DYD-ygr-.js")
), rt = t(() => import("./ODSMenu.DmIuKks-.js")), et = t(() => import("./ODSMicrophone.DLB_xKEN.js")), nt = t(
  () => import("./ODSMinimizeScreen.BrHJmO3y.js")
), st = t(() => import("./ODSMinus.BTKZBlSP.js")), ct = t(() => import("./ODSMore.0R6-8l9w.js")), mt = t(() => import("./ODSMove.DghSLQEF.js")), pt = t(() => import("./ODSMute.DB_ta66z.js")), at = t(() => import("./ODSNotification.V3CiRSug.js")), St = t(() => import("./ODSPause.DtBnkG3_.js")), Dt = t(() => import("./ODSPin.z90ki7Pv.js")), Ot = t(() => import("./ODSPlay.C8Y3JM3S.js")), lt = t(() => import("./ODSPopUpWindow.BRd80KJT.js")), dt = t(() => import("./ODSPower.LVEyzBPO.js")), ut = t(() => import("./ODSPrevious.e1vBArxy.js")), ht = t(() => import("./ODSPrint.BeuLPsFt.js")), gt = t(() => import("./ODSPublish.o9LdlcX9.js")), wt = t(() => import("./ODSRecord.5QejTnG-.js")), ft = t(() => import("./ODSRefresh.BZhj7cqm.js")), bt = t(() => import("./ODSReplyAll.D18EVkiX.js")), vt = t(() => import("./ODSReplyForward.CBWGjkNi.js")), yt = t(() => import("./ODSRestart.BgywoWKB.js")), kt = t(() => import("./ODSReturn.-0hGbKXK.js")), Ct = t(() => import("./ODSSearch.BxL0xE9G.js")), Mt = t(() => import("./ODSShare.c1x2sMS1.js")), Wt = t(() => import("./ODSShoppingCart.CKvJAOrX.js")), Pt = t(() => import("./ODSShuffle.CsXuo4Ak.js")), At = t(() => import("./ODSSort.Dn-HG3ig.js")), Ft = t(() => import("./ODSSoundOn.CodjaSvm.js")), Lt = t(() => import("./ODSStar.BTAW0d6R.js")), xt = t(() => import("./ODSSuccess.BGwdrxP-.js")), Tt = t(() => import("./ODSThumbsDown.CXtJ_r5C.js")), It = t(() => import("./ODSThumbsUp.CO8-DIlA.js")), Rt = t(() => import("./ODSTilesAdd.CmBB5Cvr.js")), Ut = t(() => import("./ODSUngroup.BYpo6Nq9.js")), Bt = t(() => import("./ODSUpload.D7wBI_M_.js")), Et = t(
  () => import("./ODSUploadToCloud.BmXD3BqJ.js")
), zt = t(
  () => import("./ODSVisibilityOff.CafTJkUG.js")
), Ht = t(() => import("./ODSVisibilityOn.B7VoLDFp.js")), Nt = t(() => import("./ODSVolumeDown.CmuNJoMg.js")), Vt = t(() => import("./ODSVolumeUp.GYtUjtFn.js")), Gt = t(() => import("./ODSZoomIn.CI4CFM4u.js")), qt = t(() => import("./ODSZoomOut.ki-PZ9C-.js")), Kt = t(
  () => import("./ODSAntivirusProtection.DYSi7xYb.js")
), Zt = t(() => import("./ODSCompliance.EBC-7aGY.js")), jt = t(
  () => import("./ODSCyberSecurity.xfbickKK.js")
), $t = t(() => import("./ODSError.CB4SQsOc.js")), Jt = t(() => import("./ODSHelp.CuKlLOYJ.js")), Qt = t(() => import("./ODSHighPriority.BuFgfB-o.js")), Xt = t(
  () => import("./ODSImprintDataprivacy.n3ieuSX0.js")
), Yt = t(() => import("./ODSInformation.BXg-pBYp.js")), _t = t(() => import("./ODSLegal.DQFEt2FN.js")), to = t(
  () => import("./ODSNetworkDisrupted.B74KiwNo.js")
), oo = t(
  () => import("./ODSPasswordBreaking.Csw07hnO.js")
), io = t(() => import("./ODSSecurity.CTWgbp6P.js")), ro = t(
  () => import("./ODSTrafficDisruption.BOLoA0rc.js")
), eo = t(() => import("./ODSUnknown.BpC9AECm.js")), no = t(() => import("./ODSWarning.lLD4wx7E.js")), so = t(() => import("./ODSAddPhone.C8P2KTa1.js")), co = t(() => import("./ODSBlog.CnSh1wbD.js")), mo = t(() => import("./ODSCall.hIZ8Hvn-.js")), po = t(() => import("./ODSCallIncoming.DHL3Sy4L.js")), ao = t(() => import("./ODSCallOutgoing.CuIzD2bT.js")), So = t(() => import("./ODSChat.B7Q5w0Pi.js")), Do = t(() => import("./ODSChatBadge.BTCfvSzP.js")), Oo = t(() => import("./ODSChatText.B9vlLc1X.js")), lo = t(() => import("./ODSEmail.CU9b0ea5.js")), uo = t(() => import("./ODSEndCall.C1Nf3xj4.js")), ho = t(() => import("./ODSFeedback.C4ZIhmQ8.js")), go = t(() => import("./ODSFlightMode.9tPSP5dk.js")), wo = t(() => import("./ODSHappyPerson.C7ghNaJz.js")), fo = t(() => import("./ODSInbox.BN7XJ9mQ.js")), bo = t(
  () => import("./ODSLoyaltyEarned.hDA6dFgb.js")
), vo = t(() => import("./ODSLoyaltyLost.wPsxXCFg.js")), yo = t(() => import("./ODSMailOpened.ftgmbInE.js")), ko = t(() => import("./ODSMessage.DyMJijXD.js")), Co = t(
  () => import("./ODSMessageIncoming.CrDDCrjn.js")
), Mo = t(
  () => import("./ODSMessageOutgoing.PFBJXjLb.js")
), Wo = t(() => import("./ODSMms.D_VFgS4p.js")), Po = t(
  () => import("./ODSMobilePhoneNumber.C4AP4a5w.js")
), Ao = t(() => import("./ODSMobileSignal.CZ-uVofJ.js")), Fo = t(() => import("./ODSNewEmail.Ch7jcSPO.js")), Lo = t(() => import("./ODSOutbox.DIiJMYfI.js")), xo = t(() => import("./ODSRecipient.nFtOIU8V.js")), To = t(
  () => import("./ODSSaveEmailsToDrafts.C4RKMD_G.js")
), Io = t(() => import("./ODSSms.rdzIbwiw.js")), Ro = t(() => import("./ODSSpam.CpDFETpI.js")), Uo = t(
  () => import("./ODSVoiceMessages.89RZCwZA.js")
), Bo = t(() => import("./ODSAchievement.BwB7ryh5.js")), Eo = t(() => import("./ODSAndroid.BJj9J4TD.js")), zo = t(() => import("./ODSApi.uFQOoa3w.js")), Ho = t(() => import("./ODSApple.CiMFwh1W.js")), No = t(() => import("./ODSApplications.C9NEI8Bf.js")), Vo = t(() => import("./ODSAt.CETTdyqq.js")), Go = t(
  () => import("./ODSAvailableKeychain.bYIthw5A.js")
), qo = t(() => import("./ODSBank.CS4WZAgT.js")), Ko = t(() => import("./ODSBattery.DAVcwdz3.js")), Zo = t(
  () => import("./ODSBatteryChargeOptimize.DqclrT7a.js")
), jo = t(() => import("./ODSBiometric.oni-wyUX.js")), $o = t(() => import("./ODSBirthday.DeMnVGYY.js")), Jo = t(() => import("./ODSBookmark.DgmQEkU5.js")), Qo = t(() => import("./ODSCalendar.DQYNvuib.js")), Xo = t(() => import("./ODSClipboard.CD3HuhCG.js")), Yo = t(() => import("./ODSClock.9VQs8nHb.js")), _o = t(() => import("./ODSCloud.Cv8pc1wK.js")), ti = t(
  () => import("./ODSCloudSecurity.BSdRL6l7.js")
), oi = t(() => import("./ODSCodeScanner.DVU-n2VS.js")), ii = t(
  () => import("./ODSColorSelection.CayyI05-.js")
), ri = t(() => import("./ODSCompany.CUGYaAN2.js")), ei = t(() => import("./ODSCountry.DcjZf_0y.js")), ni = t(() => import("./ODSCpu.pnf-ROcz.js")), si = t(() => import("./ODSCreditCard.XAVMp2gk.js")), ci = t(
  () => import("./ODSDataVisualisation.DIjw1K0E.js")
), mi = t(
  () => import("./ODSDigitalBanking.Cl6NZ7I0.js")
), pi = t(() => import("./ODSDigitalMedia.CuaFPuhO.js")), ai = t(() => import("./ODSDiscount.S-mZCc7O.js")), Si = t(() => import("./ODSDiscount3.piJhA6pH.js")), Di = t(() => import("./ODSESim.BqlWCEFy.js")), Oi = t(() => import("./ODSEu.8_0tqUPi.js")), li = t(() => import("./ODSFaceMask.CwzKte65.js")), di = t(() => import("./ODSFeatures.FYQyaCe4.js")), ui = t(
  () => import("./ODSFlexibleTariffs.3ezT0jcV.js")
), hi = t(() => import("./ODSFolder.DvoluU0B.js")), gi = t(() => import("./ODSFood.8vDtbHTF.js")), wi = t(
  () => import("./ODSGenderDiverse.C0xkgL-Z.js")
), fi = t(() => import("./ODSGenderFemale.lOlmX3e9.js")), bi = t(() => import("./ODSGenderMale.Dw2KclVJ.js")), vi = t(
  () => import("./ODSGenderNeutral.DV17M1W2.js")
), yi = t(() => import("./ODSHalfRating.Cf7K1rKj.js")), ki = t(() => import("./ODSHeart.CYFpVqse.js")), Ci = t(() => import("./ODSHeight.B-aM8fdN.js")), Mi = t(() => import("./ODSHistory.DylF0Myt.js")), Wi = t(() => import("./ODSHourGlass.BBZU32Mp.js")), Pi = t(() => import("./ODSId.BSG__yQg.js")), Ai = t(() => import("./ODSInStock.BWca7JSH.js")), Fi = t(() => import("./ODSInternational.D6n_edol.js")), Li = t(
  () => import("./ODSInternationalSms.BKeqgvlW.js")
), xi = t(() => import("./ODSKey.c6DCYIUT.js")), Ti = t(() => import("./ODSLanguage.BwfZ02J1.js")), Ii = t(() => import("./ODSLightbulb.ChbhB-CV.js")), Ri = t(() => import("./ODSLock.CihpmOSi.js")), Ui = t(() => import("./ODSLoyalty.gQbdt1Tj.js")), Bi = t(() => import("./ODSMediaFolder.CDvF_V24.js")), Ei = t(
  () => import("./ODSMicrophoneExternal.CINRC7iN.js")
), zi = t(() => import("./ODSMultiSim.BP2oUOe5.js")), Hi = t(() => import("./ODSMusic.C9YJZvOL.js")), Ni = t(() => import("./ODSNews.B99TO_PN.js")), Vi = t(() => import("./ODSOutOfStock.6vEhcThs.js")), Gi = t(() => import("./ODSPackage.Dy3Clqog.js")), qi = t(
  () => import("./ODSPackageDelivery.j8_iZi2l.js")
), Ki = t(
  () => import("./ODSPersonWalking.Btw84myd.js")
), Zi = t(
  () => import("./ODSPrepaidActivate.DR1kN2Z9.js")
), ji = t(() => import("./ODSPriceTag.D9KGJIO_.js")), $i = t(() => import("./ODSRoute.DQzknwPy.js")), Ji = t(() => import("./ODSRss.DozAtHIY.js")), Qi = t(() => import("./ODSSale.Dy1OswYE.js")), Xi = t(() => import("./ODSShop.CrGBCtmM.js")), Yi = t(() => import("./ODSSignal.BWilE291.js")), _i = t(() => import("./ODSSimCard.CKNukQw0.js")), tr = t(() => import("./ODSSimInactive.Bs18RfBA.js")), or = t(() => import("./ODSSmile.B5r7yzW2.js")), ir = t(
  () => import("./ODSSortIndicatorDown.DStES077.js")
), rr = t(
  () => import("./ODSSortIndicatorUp.Dgp0TcYq.js")
), er = t(
  () => import("./ODSStatusInactive.MBzbDB5S.js")
), nr = t(() => import("./ODSStopwatch.B3HkuH_v.js")), sr = t(() => import("./ODSSupportChat.Cyl89l-6.js")), cr = t(() => import("./ODSSustainable.DJ9w9RTM.js")), mr = t(() => import("./ODSTariffs.D_QfOwed.js")), pr = t(() => import("./ODSTemperature.DF9tJdUd.js")), ar = t(() => import("./ODSThreats.DikEjKgG.js")), Sr = t(() => import("./ODSToDoList.CgjD11jW.js")), Dr = t(() => import("./ODSTools.D418EjjY.js")), Or = t(() => import("./ODSTransport.M8TEJlas.js")), lr = t(
  () => import("./ODSTwoFactorAuthentification.CgUPliIt.js")
), dr = t(() => import("./ODSUnlock.CNiWrc-P.js")), ur = t(() => import("./ODSVoucher.BqE_1YfN.js")), hr = t(() => import("./ODSWaiting.D1JJ1gvc.js")), gr = t(() => import("./ODSWallet.Cq8E6GMA.js")), wr = t(() => import("./ODSAddDevice.CNHvf2m7.js")), fr = t(() => import("./ODSCameraOff.CGvArTEX.js")), br = t(() => import("./ODSChangeCamera.By34YVOk.js")), vr = t(() => import("./ODSComputer.COoDpis2.js")), yr = t(
  () => import("./ODSControllerDevice.D6kI_KIX.js")
), kr = t(
  () => import("./ODSDeviceEthernet.CNV75k8x.js")
), Cr = t(() => import("./ODSDeviceTv.C9nYXnUs.js")), Mr = t(() => import("./ODSDongle.B4k6vepI.js")), Wr = t(() => import("./ODSFax.DR7Xz1SS.js")), Pr = t(
  () => import("./ODSFixedLineServices.BR6Tb8ql.js")
), Ar = t(
  () => import("./ODSFixedLineServices3.-JxTGZDe.js")
), Fr = t(
  () => import("./ODSGameController.DzjpOaUl.js")
), Lr = t(
  () => import("./ODSMediaReceiver.iloX2kTb.js")
), xr = t(() => import("./ODSMeshWifi.DOOhRSxS.js")), Tr = t(() => import("./ODSMobileData.BAN9aXph.js")), Ir = t(
  () => import("./ODSMobileDevices.bItDzShm.js")
), Rr = t(
  () => import("./ODSMobileEquipment.CDnDFRQW.js")
), Ur = t(
  () => import("./ODSMobilePhoneInsurance.DO_pUget.js")
), Br = t(
  () => import("./ODSMobileServices.DNJ_YRSd.js")
), Er = t(() => import("./ODSPhone.4SKupYrz.js")), zr = t(
  () => import("./ODSPhoneWithMobilePlan.DbOQ0ihq.js")
), Hr = t(
  () => import("./ODSPhoneWithoutMobilePlan.EkW0GMgv.js")
), Nr = t(() => import("./ODSPhotoCamera.n3ZNrrGv.js")), Vr = t(
  () => import("./ODSRemoteController.ClOY1Gkb.js")
), Gr = t(
  () => import("./ODSReplacementMobilePhone.CGIMB7mZ.js")
), qr = t(() => import("./ODSRotateLocked.BNGGnmOj.js")), Kr = t(() => import("./ODSRotateOpen.BHv9ql8g.js")), Zr = t(() => import("./ODSRouter.BtrCrg1Z.js")), jr = t(() => import("./ODSScreenRotate.sNpX78q8.js")), $r = t(() => import("./ODSServer.dGPh2Jhc.js")), Jr = t(() => import("./ODSSmartSpeaker.r35MLV6-.js")), Qr = t(() => import("./ODSTablet.B0fxXUNh.js")), Xr = t(() => import("./ODSTvAndMobile.Ca63IemE.js")), Yr = t(() => import("./ODSVideoCamera.UFdtQvAP.js")), _r = t(() => import("./ODSWatch.BE2zuAgr.js")), te = t(() => import("./ODSWifiDevice.DfwnRTZh.js")), oe = t(() => import("./ODSHome.Bw6B4cT3.js")), ie = t(() => import("./ODSInternetHome.DQZbfvT0.js")), re = t(() => import("./ODSIot.D2-CiYac.js")), ee = t(() => import("./ODSLightBulb.DaYvqy-G.js")), ne = t(
  () => import("./ODSNetworkSecure.Cw0ZspWR.js")
), se = t(() => import("./ODSPowerSocket.0vbQNbqs.js")), ce = t(() => import("./ODSPowerSocket3.BzvrUgRx.js")), me = t(
  () => import("./ODSRouterDisconnected.ChYqIELd.js")
), pe = t(() => import("./ODSSmartHome.Dw5j1riC.js")), ae = t(() => import("./ODSWifi.8eKnr89P.js")), Se = t(
  () => import("./ODSWifiConnected.COTVRD-5.js")
), De = t(
  () => import("./ODSWifiConnectionError.BTkS9qfV.js")
), Oe = t(
  () => import("./ODSWifiNoWiredInternet.Bv4ThjEr.js")
), le = t(
  () => import("./ODSWifiPreferred.d4SboRIX.js")
), de = t(() => import("./ODSWifiReduced.D-Rmn8LI.js")), ue = t(() => import("./ODSWifiSlow.9pSQEpPw.js")), he = t(() => import("./ODSWifiUnknown.kKZBX5SD.js")), ge = t(
  () => import("./ODSActionCollapseDown.2YOFh2_L.js")
), we = t(
  () => import("./ODSCircleArrowUp.CMH5dVQY.js")
), fe = t(() => import("./ODSCollapseDown.a8_lm2jI.js")), be = t(() => import("./ODSCollapseUp.Bt6gCur0.js")), ve = t(() => import("./ODSDoubleLeft.8qPIsgVZ.js")), ye = t(() => import("./ODSDoubleRight.DDP0yf1F.js")), ke = t(
  () => import("./ODSLeftCondensed.vRJXcxKA.js")
), Ce = t(() => import("./ODSLeftExtended.ntwDhr37.js")), Me = t(() => import("./ODSLocation.Bs4jCNmz.js")), We = t(() => import("./ODSMap.C-KkvjNz.js")), Pe = t(() => import("./ODSMyLocation.Cj2ZSG4a.js")), Ae = t(
  () => import("./ODSNavigationExternalLink.BRIfEbMn.js")
), Fe = t(
  () => import("./ODSNavigationLeft.DKzlkJ5J.js")
), Le = t(
  () => import("./ODSNavigationRight.Da0xs0J9.js")
), xe = t(
  () => import("./ODSNavigationStart.VQ0q_xIF.js")
), Te = t(
  () => import("./ODSRightCondensed.0UBOzZwe.js")
), Ie = t(
  () => import("./ODSRightExtended.H2djWNcs.js")
), Re = t(() => import("./ODSTopUp.Ckr1gqbj.js")), Ue = t(() => import("./ODSOrderStatus.GkORYo38.js")), Be = t(() => import("./ODSProcessing.BdPpKI0z.js")), Ee = t(
  () => import("./ODSSepaTransaction.D2WomYju.js")
), ze = t(
  () => import("./ODSDevicesService.CSGgmtnv.js")
), He = t(() => import("./ODSMaintenance.BaYHFwKp.js")), Ne = t(
  () => import("./ODSOneTimePassword.Cr0xDQEX.js")
), Ve = t(
  () => import("./ODSOperatingManual.jiSWTmaC.js")
), Ge = t(
  () => import("./ODSServiceButton.zG_NjbKh.js")
), qe = t(() => import("./ODSServices.BAHPCHtP.js")), Ke = t(() => import("./ODSSettings.B5XEWn82.js")), Ze = t(() => import("./ODSSupport.DsTEvE5t.js")), je = t(() => import("./ODSVpn.BHPKSezF.js")), $e = t(() => import("./ODSTProduct7.Cls68r1S.js")), Je = t(() => import("./ODSMagentaAi.BlpEejGG.js")), Qe = t(() => import("./ODSMagentaCloud.PjPorg-v.js")), Xe = t(() => import("./ODSMagentaOne.B8sRelw3.js")), Ye = t(() => import("./ODSMagentaTv.c5hc-fnk.js")), _e = t(
  () => import("./ODSMeasureInternetSpeed.WsRorrct.js")
), tn = t(
  () => import("./ODSPhoneWithLogo.Zq__3VbW.js")
), on = t(() => import("./ODSTelekomPlan.BI0Zb0_7.js")), rn = t(() => import("./ODSTelekomShopB.DtKWcuVR.js")), en = t(() => import("./ODSUnlimited.P-otDL2M.js")), nn = t(() => import("./ODSUsage.Dm339u5I.js")), sn = t(() => import("./ODSVoice.BlSS7H7x.js")), cn = t(() => import("./ODSAdmin.BplISEqP.js")), mn = t(() => import("./ODSAnalytics.BplnAVVX.js")), pn = t(() => import("./ODSAttachment.D4hhM2nv.js")), an = t(() => import("./ODSAudioFile.Bd27XnqI.js")), Sn = t(() => import("./ODSBilling.DUpviEvq.js")), Dn = t(() => import("./ODSBoy.3uoPF8eP.js")), On = t(
  () => import("./ODSBusinessUsers.hlvMsTcD.js")
), ln = t(() => import("./ODSCommunities.CS8E4t1p.js")), dn = t(() => import("./ODSContacts.DbTyvwBR.js")), un = t(() => import("./ODSContracts.BzECx6mj.js")), hn = t(
  () => import("./ODSContractsFromCloud.ydBW7i33.js")
), gn = t(() => import("./ODSCsv.CDL9r5ej.js")), wn = t(() => import("./ODSDraftFile.CEB-lPAW.js")), fn = t(() => import("./ODSFamilies.CzAl83xt.js")), bn = t(() => import("./ODSFamily.CuvaZbCY.js")), vn = t(() => import("./ODSFile.DGncW9vZ.js")), yn = t(
  () => import("./ODSFileCollection.DVdII91v.js")
), kn = t(() => import("./ODSGirl.DVHpTU7j.js")), Cn = t(() => import("./ODSHandshake.Cg-W3Cp6.js")), Mn = t(() => import("./ODSHtmlFile.B1-co-da.js")), Wn = t(() => import("./ODSIdCard.DE28nA0k.js")), Pn = t(() => import("./ODSImageFile.BGGupxc2.js")), An = t(() => import("./ODSLogin.BGAPI4rx.js")), Fn = t(() => import("./ODSMan.D6bmFwwv.js")), Ln = t(() => import("./ODSManual.CLzI1tXM.js")), xn = t(() => import("./ODSPdfFile.BQfqBUUN.js")), Tn = t(() => import("./ODSSwitchUsers.sCdaXUaO.js")), In = t(() => import("./ODSUser.DhFW266y.js")), Rn = t(() => import("./ODSWoman.D1gc4YNo.js")), Un = t(() => import("./ODSWeather1.hBmShQr4.js")), Bn = t(() => import("./ODSWeather2.XmS7eICw.js")), En = t(() => import("./ODSWeather3.CuK7_jWS.js")), zn = t(() => import("./ODSWeather4.D0LOxZ7d.js")), Hn = t(() => import("./ODSWeather5.Cr9oyCLh.js")), Nn = t(() => import("./ODSWeather6.BWVOaaJ1.js")), Vn = t(() => import("./ODSWeather7.Bu9h5c_T.js")), Gn = t(() => import("./ODSWeather8.A-d9UnAY.js")), qn = t(() => import("./ODSWeather9.B2__25u_.js")), Kn = t(() => import("./ODSWeather10.prQDveRo.js")), Zn = t(() => import("./ODSWeather11.Nj1subrk.js")), jn = t(() => import("./ODSWeather12.CJk_KyyN.js")), $n = t(() => import("./ODSWeather13.D9x-8Xqg.js")), Jn = t(() => import("./ODSWeather14.BZiX0q45.js")), Qn = t(() => import("./ODSWeather15.D9HmLXeo.js")), Xn = t(() => import("./ODSWeather16.1wUQpFuR.js")), Yn = t(() => import("./ODSWeather17.ByzGe4Bx.js")), _n = t(() => import("./ODSWeather18.CSdtID_o.js")), ts = t(() => import("./ODSWeather19.B6oHqkab.js")), os = t(() => import("./ODSWeather20.Bn5JV9Ba.js")), is = t(() => import("./ODSWeather21.DDsdGqoE.js")), rs = t(() => import("./ODSWeather22.R_p3j4uk.js")), es = {
  add: a,
  "add-card": S,
  arrange: D,
  "arrow-down": O,
  "arrow-left": l,
  "arrow-right": d,
  "arrow-u-turn-backwards": u,
  "arrow-u-turn-forwards": h,
  "arrow-up": g,
  "auto-login": w,
  backspace: f,
  backward: b,
  cast: v,
  changelog: y,
  checkmark: k,
  "circle-add": C,
  "circle-close": M,
  "circle-fast-forward": W,
  "circle-minus": P,
  "circle-pause": A,
  "circle-play": F,
  close: L,
  compare: x,
  "copy-paste": T,
  "cut-paste": I,
  delete: R,
  "disabled-microphone": U,
  "dot-grid": B,
  download: E,
  "download-from-cloud": z,
  "drag-and-drop": H,
  edit: N,
  export: V,
  "fast-forward": G,
  filter: q,
  "filter-2": K,
  forward: Z,
  group: j,
  import: $,
  install: J,
  launch: Q,
  "light-dark-mode": X,
  link: Y,
  logout: _,
  loop: tt,
  "magic-wand": ot,
  "maximize-screen": it,
  menu: rt,
  microphone: et,
  "minimize-screen": nt,
  minus: st,
  more: ct,
  move: mt,
  mute: pt,
  notification: at,
  pause: St,
  pin: Dt,
  play: Ot,
  "pop-up-window": lt,
  power: dt,
  previous: ut,
  print: ht,
  publish: gt,
  record: wt,
  refresh: ft,
  "reply-all": bt,
  "reply-forward": vt,
  restart: yt,
  return: kt,
  search: Ct,
  share: Mt,
  "shopping-cart": Wt,
  shuffle: Pt,
  sort: At,
  "sound-on": Ft,
  star: Lt,
  success: xt,
  "thumbs-down": Tt,
  "thumbs-up": It,
  "tiles-add": Rt,
  ungroup: Ut,
  upload: Bt,
  "upload-to-cloud": Et,
  "visibility-off": zt,
  "visibility-on": Ht,
  "volume-down": Nt,
  "volume-up": Vt,
  "zoom-in": Gt,
  "zoom-out": qt,
  "antivirus-protection": Kt,
  compliance: Zt,
  "cyber-security": jt,
  error: $t,
  help: Jt,
  "high-priority": Qt,
  "imprint-dataprivacy": Xt,
  information: Yt,
  legal: _t,
  "network-disrupted": to,
  "password-breaking": oo,
  security: io,
  "traffic-disruption": ro,
  unknown: eo,
  warning: no,
  "add-phone": so,
  blog: co,
  call: mo,
  "call-incoming": po,
  "call-outgoing": ao,
  chat: So,
  "chat-badge": Do,
  "chat-text": Oo,
  email: lo,
  "end-call": uo,
  feedback: ho,
  "flight-mode": go,
  "happy-person": wo,
  inbox: fo,
  "loyalty-earned": bo,
  "loyalty-lost": vo,
  "mail-opened": yo,
  message: ko,
  "message-incoming": Co,
  "message-outgoing": Mo,
  mms: Wo,
  "mobile-phone-number": Po,
  "mobile-signal": Ao,
  "new-email": Fo,
  outbox: Lo,
  recipient: xo,
  "save-emails-to-drafts": To,
  sms: Io,
  spam: Ro,
  "voice-messages": Uo,
  achievement: Bo,
  android: Eo,
  api: zo,
  apple: Ho,
  applications: No,
  at: Vo,
  "available-keychain": Go,
  bank: qo,
  battery: Ko,
  "battery-charge-optimize": Zo,
  biometric: jo,
  birthday: $o,
  bookmark: Jo,
  calendar: Qo,
  clipboard: Xo,
  clock: Yo,
  cloud: _o,
  "cloud-security": ti,
  "code-scanner": oi,
  "color-selection": ii,
  company: ri,
  country: ei,
  cpu: ni,
  "credit-card": si,
  "data-visualisation": ci,
  "digital-banking": mi,
  "digital-media": pi,
  discount: ai,
  "discount-3": Si,
  "e-sim": Di,
  eu: Oi,
  "face-mask": li,
  features: di,
  "flexible-tariffs": ui,
  folder: hi,
  food: gi,
  "gender-diverse": wi,
  "gender-female": fi,
  "gender-male": bi,
  "gender-neutral": vi,
  "half-rating": yi,
  heart: ki,
  height: Ci,
  history: Mi,
  "hour-glass": Wi,
  id: Pi,
  "in-stock": Ai,
  international: Fi,
  "international-sms": Li,
  key: xi,
  language: Ti,
  lightbulb: Ii,
  lock: Ri,
  loyalty: Ui,
  "media-folder": Bi,
  "microphone-external": Ei,
  "multi-sim": zi,
  music: Hi,
  news: Ni,
  "out-of-stock": Vi,
  package: Gi,
  "package-delivery": qi,
  "person-walking": Ki,
  "prepaid-activate": Zi,
  "price-tag": ji,
  route: $i,
  rss: Ji,
  sale: Qi,
  shop: Xi,
  signal: Yi,
  "sim-card": _i,
  "sim-inactive": tr,
  smile: or,
  "sort-indicator-down": ir,
  "sort-indicator-up": rr,
  "status-inactive": er,
  stopwatch: nr,
  "support-chat": sr,
  sustainable: cr,
  tariffs: mr,
  temperature: pr,
  threats: ar,
  "to-do-list": Sr,
  tools: Dr,
  transport: Or,
  "two-factor-authentification": lr,
  unlock: dr,
  voucher: ur,
  waiting: hr,
  wallet: gr,
  "add-device": wr,
  "camera-off": fr,
  "change-camera": br,
  computer: vr,
  "controller-device": yr,
  "device-ethernet": kr,
  "device-tv": Cr,
  dongle: Mr,
  fax: Wr,
  "fixed-line-services": Pr,
  "fixed-line-services-3": Ar,
  "game-controller": Fr,
  "media-receiver": Lr,
  "mesh-wifi": xr,
  "mobile-data": Tr,
  "mobile-devices": Ir,
  "mobile-equipment": Rr,
  "mobile-phone-insurance": Ur,
  "mobile-services": Br,
  phone: Er,
  "phone-with-mobile-plan": zr,
  "phone-without-mobile-plan": Hr,
  "photo-camera": Nr,
  "remote-controller": Vr,
  "replacement-mobile-phone": Gr,
  "rotate-locked": qr,
  "rotate-open": Kr,
  router: Zr,
  "screen-rotate": jr,
  server: $r,
  "smart-speaker": Jr,
  tablet: Qr,
  "tv-and-mobile": Xr,
  "video-camera": Yr,
  watch: _r,
  "wifi-device": te,
  home: oe,
  "internet-home": ie,
  iot: re,
  "light-bulb": ee,
  "network-secure": ne,
  "power-socket": se,
  "power-socket-3": ce,
  "router-disconnected": me,
  "smart-home": pe,
  wifi: ae,
  "wifi-connected": Se,
  "wifi-connection-error": De,
  "wifi-no-wired-internet": Oe,
  "wifi-preferred": le,
  "wifi-reduced": de,
  "wifi-slow": ue,
  "wifi-unknown": he,
  "action-collapse-down": ge,
  "circle-arrow-up": we,
  "collapse-down": fe,
  "collapse-up": be,
  "double-left": ve,
  "double-right": ye,
  "left-condensed": ke,
  "left-extended": Ce,
  location: Me,
  map: We,
  "my-location": Pe,
  "navigation-external-link": Ae,
  "navigation-left": Fe,
  "navigation-right": Le,
  "navigation-start": xe,
  "right-condensed": Te,
  "right-extended": Ie,
  "top-up": Re,
  "order-status": Ue,
  processing: Be,
  "sepa-transaction": Ee,
  "devices-service": ze,
  maintenance: He,
  "one-time-password": Ne,
  "operating-manual": Ve,
  "service-button": Ge,
  services: qe,
  settings: Ke,
  support: Ze,
  vpn: je,
  "t-product-7": $e,
  "magenta-ai": Je,
  "magenta-cloud": Qe,
  "magenta-one": Xe,
  "magenta-tv": Ye,
  "measure-internet-speed": _e,
  "phone-with-logo": tn,
  "telekom-plan": on,
  "telekom-shop-b": rn,
  unlimited: en,
  usage: nn,
  voice: sn,
  admin: cn,
  analytics: mn,
  attachment: pn,
  "audio-file": an,
  billing: Sn,
  boy: Dn,
  "business-users": On,
  communities: ln,
  contacts: dn,
  contracts: un,
  "contracts-from-cloud": hn,
  csv: gn,
  "draft-file": wn,
  families: fn,
  family: bn,
  file: vn,
  "file-collection": yn,
  girl: kn,
  handshake: Cn,
  "html-file": Mn,
  "id-card": Wn,
  "image-file": Pn,
  login: An,
  man: Fn,
  manual: Ln,
  "pdf-file": xn,
  "switch-users": Tn,
  user: In,
  woman: Rn,
  "weather-1": Un,
  "weather-2": Bn,
  "weather-3": En,
  "weather-4": zn,
  "weather-5": Hn,
  "weather-6": Nn,
  "weather-7": Vn,
  "weather-8": Gn,
  "weather-9": qn,
  "weather-10": Kn,
  "weather-11": Zn,
  "weather-12": jn,
  "weather-13": $n,
  "weather-14": Jn,
  "weather-15": Qn,
  "weather-16": Xn,
  "weather-17": Yn,
  "weather-18": _n,
  "weather-19": ts,
  "weather-20": os,
  "weather-21": is,
  "weather-22": rs
}, ps = ({ name: i, ...r }) => {
  let s, e = !1, o;
  if (i != null && i.includes("-type-bold") ? (s = !0, o = i.replace("-type-bold", "")) : o = i ? i.replace("-type-standard", "") : void 0, i != null && i.includes("-size-small") && (e = !0, o = o == null ? void 0 : o.replace("-size-small", "")), o !== void 0 && o.length > 0) {
    const c = es[o];
    if (!c)
      return console.error(`Icon with name "${o}" not found.`), null;
    const m = e ? (r == null ? void 0 : r.size) ?? 24 : (r == null ? void 0 : r.size) ?? 16;
    return /* @__PURE__ */ n(
      p,
      {
        fallback: /* @__PURE__ */ n("div", { className: "ODSIcon-placeholder", style: { width: m, height: m } }),
        children: /* @__PURE__ */ n(c, { selected: s, small: e, ...r })
      }
    );
  }
  return null;
};
export {
  ps as O
};
//# sourceMappingURL=ODSIcon.DjL6Q3o4.js.map
